<template>
    <div class="chat-container">
      <div class="chat-list chat-card" v-if="(anyActiveChats && !chatInfo && $uiHelpers.isPortrait) || !$uiHelpers.isPortrait">
        <div class="pat-profs-select" v-if="$store.getters['session/userIsProfessional']">
          <base-button class="mr-1 d-flex justify-content-center" style="width:50%" :white="isChatWithProfs" @click="setUserType(PATIENT_ROLE)"><span>{{ $t('chats.patients') }}</span></base-button><base-button class="ml-1 d-flex justify-content-center" style="width:50%" :white="!isChatWithProfs" @click="setUserType(PROFESSIONAL_ROLE)"><span>{{ $t('chats.professionals') }}</span></base-button>
        </div>
        <div>
          <ul>
            <li class="chat-list-item" v-if="$store.getters['session/userIsProfessional']" @click="contactUser()">
              <div class="photo-name-wrapper">
                <div class="photo-align">
                  <img :src="defaultImg" alt="" class="chat-list-photo chat-list-icon" />
                </div>
                <span v-if="isChatWithProfs">{{ $t('chats.contact-prof') }}</span>
                <span v-else>{{ $t('chats.contact-patient') }}</span>
              </div>
            </li>
            <li v-for="chat in chatList" :key="chat.idAppointment" @click="selectChat(chat)" class="chat-list-item" :class="[chatInfo === chat ? 'selected' : '']">
              <div class="photo-name-wrapper">
                <div :class="[!chat.createdByDoctor ? 'photo-align' : '']">
                  <span class="contact-status" :class="[chat.conexionState === 'online' ? 'connected' : '' ]"></span>
                  <img :src="chat.urlPhoto" alt="" class="chat-list-photo" />
                </div>
                <div class="d-flex flex-column">
                  <b-row class="item-block"><span>{{ chat.name }}</span></b-row>
                  <b-row v-if="chat.interconsultation" class="item-block"><b-icon-person-fill class="align-items-center mt-1 mr-1"></b-icon-person-fill><span>{{ chat.interconsultation.subject }}</span></b-row>
                </div>
                <span v-if="chat.numMessagesPendingRead" class="unread-messages">{{ chat.numMessagesPendingRead }}</span>
              </div>
            </li>
            <li class="chat-list-item" v-if="pastChat" @click.once="getAllChats()">
              <div class="photo-name-wrapper">
                <div class="photo-align">
                  <img src="/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg" alt="" class="chat-list-photo chat-list-icon" />
                </div>
                <span>{{ $t('chats.view-all') }}</span>
              </div>
            </li>
            <li class="chat-list-item" v-else @click.once="getPastChats()">
              <div class="photo-name-wrapper">
                <div class="photo-align">
                  <img src="/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg" alt="" class="chat-list-photo chat-list-icon" />
                </div>
                <span>{{ $t('chats.finished-chats') }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="chat-box chat-card" v-if="chatInfo">
        <div class="chat-header">
          <b-icon-arrow-left v-if="$uiHelpers.isPortrait" @click="$store.commit('chat/unselectChat')" class="back-arrow" style="cursor: pointer"></b-icon-arrow-left>
          <img :src="chatInfo.urlPhoto" alt="" class="photo" />
          <div class="user-info" :style="chatInfo.customPageUrl ? 'cursor: pointer;' : ''" @click="goToProfPage">
            <b-row><p class="chat-name">{{ chatInfo.name }}</p></b-row>
            <b-row><p class="chat-id">Id: {{ chatInfo.idAppointment }}</p></b-row>
          </div>
          <div class="cancel-consultation" v-if="chatInfo.canCancel">
            <!-- <base-button class="action-button" red :textColor="SECONDARY" @click="toggleShowDialog('cancel')"><b-icon-x-circle></b-icon-x-circle><span>{{ $t('chats.cancel-chat') }}</span></base-button> hay que actualizar el método en la api para que puedan cancelar tanto pacientes como profesionales -->
            <base-button class="action-button" v-if="dontAttendChatButton" red :textColor="SECONDARY" @click="toggleShowDialog('dontAttend')"><b-icon-x-circle></b-icon-x-circle><span>{{ $t('chats.dont-attend-chat') }}</span></base-button>
            <base-button class="action-button" v-else red :textColor="SECONDARY" @click="goCancelAppointment()"><b-icon-x-circle></b-icon-x-circle><span>{{ $t('chats.cancel-chat') }}</span></base-button>
          </div>
        </div>
        <div class="interconsultation-confirmation" v-if="hasToAcceptInterconsultation">
          <span>{{ $t('chats.new-interconsultation') }}</span>
          <strong><span>{{ interconsultation.subject }}</span></strong>
          <div class="mt-2">
            <base-button class="mt-2" @click="acceptInterconsultation(true)"><span>{{$t('dialog.ok-button')}}</span></base-button>
            <base-button class="mt-2" @click="acceptInterconsultation()" red :textColor="SECONDARY"><span>{{$t('dialog.reject-button')}}</span></base-button>
          </div>
        </div>
        <div class="interconsultation-confirmation " v-else-if="waitingForDoctorToAccept">
          <span>{{ $t('chats.not-yet-accepted-interconsultation') }}</span>
          <base-button class="mt-2" @click="acceptInterconsultation()" red :textColor="SECONDARY"><span>{{`${$t('cancel')} ${$t('chats.interconsultation')}`}}</span></base-button>
        </div>
        <div class="interconsultation-confirmation " v-if="interconsultation && interconsultation.accepted && !interconsultation.clinicHistoryAllowed">
          <span>{{ $t('chats.waiting-for-clinic-history') }}</span>
        </div>
        <div v-if="interconsultation && showInterconsultationAnchored" :class="['z-2', interconsultationBlurred ? 'pending-chat-actions' : '']">
          <base-button class="interconsultation-button anchored" @click="getInterconsultationUrl()"><span><b-icon-person></b-icon-person> {{ interconsultation.matterName }}</span><br><span class="subject">{{ interconsultation.subject }}</span></base-button>
        </div>
        <div :class="['chat-content', interconsultationBlurred ? 'pending-chat-actions' : '']" ref="messageList" @scroll.passive="handleScroll()">
          <ul>
            <li v-for="(msg, index) in chatMessages" :key="msg.chatMessageId">
              <div v-if="$store.state.chat.messagesPendingReadLabel > 0 && index === firstUnreadMessageIndex" class="messages-pending-read" ref="messagesPendingRead">
                <!-- <b-icon-arrow-down-short></b-icon-arrow-down-short> <strong><span v-if="$store.state.chat.messagesPendingReadLabel === 1">{{ $store.state.chat.messagesPendingReadLabel }} {{ $t('chats.unread-message') }}</span><span v-else>{{ $store.state.chat.messagesPendingReadLabel }} {{ $t('chats.unread-messages') }}</span></strong> <b-icon-arrow-down-short></b-icon-arrow-down-short> -->
              </div>
                <base-button v-if="interconsultation && index === firstInterconsultationIndex" ref="interconsultationButton" class="interconsultation-button mt-5" @click="getInterconsultationUrl()"><span><b-icon-person></b-icon-person> {{ interconsultation.matterName }}</span><br><span class="subject">{{ interconsultation.subject }}</span></base-button>
              <chat-message :msg="msg" :userPhoto="chatInfo.urlPhoto"></chat-message>
            </li>
          </ul>
          <base-dialog v-model="$store.state.chat.showDialog.finish" :content="$t('chats.finish-chat-message')" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :okFn="() => { finishChatMessage() }" :cancelFn="() => { toggleShowDialog('finish') }"></base-dialog>
          <base-dialog v-model="$store.state.chat.showDialog.ePrescription" :content="$t('chats.emit-eprescription-message')" :okBtnText="$t('continue')" :okFn="() => { emitEPrescription() }" :cancelFn="() => { toggleShowDialog('ePrescription') }"></base-dialog>
          <base-dialog v-model="$store.state.chat.showDialog.dontAttend" :content="$t('chats.reassign-chat')" :okBtnText="$t('continue')" :okFn="() => { reassignChat() }" :cancelFn="() => { toggleShowDialog('dontAttend') }"></base-dialog>
          <cancel-appointment-modal :showDialog="$store.state.chat.showDialog.cancel" :appointmentId="chatInfo.idAppointment" @toggleCancelAppointment="toggleShowDialog('cancel')"></cancel-appointment-modal>
          <consolidate-appointment-modal :value="showFinishModal" :isBillable="chatInfo.showBillingSelectorOnConsolidate" :billingEntity="chatInfo.useCenterBillingInfo" @consolidate="consolidateChat"></consolidate-appointment-modal>
          <button v-if="showScrollBottomButton" class="scroll-end-btn" @click="$uiHelpers.scrollBottom($refs.messageList, true)"><b-icon-arrow-down class="icon"></b-icon-arrow-down></button>
        </div>

        <div v-if="!chatInfo.terminated" ref="messageInput" :class="[interconsultationBlurred ? 'pending-chat-actions' : '']">
          <chat-message-input @sentMessage="setChatFirst"></chat-message-input>
          <b-row class="finish-consultation-options" v-if="showFinishButton || chatInfo.ePrescriptionAvailable">
            <b-row class="e-prescription" v-if="chatInfo.ePrescriptionAvailable">
              <base-button class="action-button" :textColor="SECONDARY" @click="toggleShowDialog('ePrescription')"><b-icon-file-medical></b-icon-file-medical><span>{{ $t('chats.emit-eprescription') }}</span></base-button>
            </b-row>
            <b-row class="finish-consultation" v-if="showFinishButton">
              <base-button class="action-button" red :textColor="SECONDARY" @click="toggleShowDialog('finish')"><b-icon-telephone-x-fill></b-icon-telephone-x-fill><span>{{ $t('chats.finish-chat') }}</span></base-button>
            </b-row>
          </b-row>
        </div>
        <div v-else-if="chatInfo.terminated && !chatInfo.reviewed" :class="['d-flex', 'justify-content-center', interconsultationBlurred ? 'pending-chat-actions' : '']">
          <base-button class="mb-3" @click="$helpers.goToPatientWebApp(`appointments/review/${chatInfo.idAppointment}`, $apiToken)"><b-icon-hand-thumbs-up-fill class="mr-2"></b-icon-hand-thumbs-up-fill><span>{{this.$t('review')}}</span></base-button>
        </div>
      </div>
      <div class="chat-box chat-card " v-else-if="!anyActiveChats">
        <div class="pat-profs-select" v-if="$store.getters['session/userIsProfessional'] && $uiHelpers.isPortrait">
          <base-button class="mr-1 d-flex justify-content-center" style="width:50%" :white="isChatWithProfs" @click="setUserType(PATIENT_ROLE)"><span>{{ $t('chats.patients') }}</span></base-button><base-button class="ml-1 d-flex justify-content-center" style="width:50%" :white="!isChatWithProfs" @click="setUserType(PROFESSIONAL_ROLE)"><span>{{ $t('chats.professionals') }}</span></base-button>
        </div>
        <div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
          <span>{{ $t('chats.no-active-chat') }}</span>
          <base-button v-if="$store.getters['session/userIsPatient']" class="mt-2" @click="$router.push(`/patient/search?appointmentType=${CHAT}`)"><span>{{$t('chats.ask-for-new-chat')}}</span></base-button>
          <base-button v-if="$store.getters['session/userIsProfessional']" class="mt-2" @click="contactUser()"><span>{{`${ isChatWithProfs ? $t('chats.contact-prof') : $t('chats.contact-patient')}`}}</span></base-button>
          <base-button v-if="$uiHelpers.isPortrait" class="mt-2" @click="getPastChats()"><span>{{this.$t('chats.finished-chats')}}</span></base-button>
        </div>
      </div>
      <administrative-chat-modal :isChatWithProf="isChatWithProfs" :openedFromOuicare="isOpenedFromOuicare" @createAdministrativeChat="createChat"></administrative-chat-modal>
    </div>
  </template>
<script>

import { CHAT } from '@/constants/consultationTypes'
import { SECONDARY } from '@/constants/colours'
import BaseInput from '@/components/base/forms/BaseInput.vue'
import BaseDialog from '@/components/base/BaseDialog'
import { BIcon } from 'bootstrap-vue'
import BaseButton from '@/components/base/buttons/BaseButton.vue'
import ChatMessage from './ChatMessage.vue'
import ChatRepository from '@/repositories/ChatRepository'
import ChipcardRepository from '@/repositories/ChipcardRepository'
import { NEW_CHAT_MESSAGE, EDIT_CHAT_MESSAGE, DELETE_CHAT_MESSAGE, CHAT_CREATED_BY_DOCTOR, CHAT_CONSOLIDATED, INTERCONSULTATION_ACTION, CHAT_REASSIGNED } from '@/constants/signalRCommands'
import { PATIENT_ROLE, PROFESSIONAL_ROLE } from '@/constants/roles'
import CancelAppointmentModal from '@/components/webapp/shared/CancelAppointmentModal.vue'
import ConsolidateAppointmentModal from '@/components/webapp/shared/ConsolidateAppointmentModal.vue'
import AdministrativeChatModal from './AdministrativeChatModal.vue'
import ChatMessageInput from './ChatMessageInput.vue'

export default {
  components: {
    BaseInput,
    BaseDialog,
    BIcon,
    BaseButton,
    ChatMessage,
    ChatMessageInput,
    CancelAppointmentModal,
    ConsolidateAppointmentModal,
    AdministrativeChatModal
  },
  props: {
    role: {
      type: String,
      required: false,
      default: PATIENT_ROLE
    }
  },
  data () {
    return {
      chats: [],
      userType: this.role,
      showFinishModal: false,
      pastChatInfo: null,
      showScrollBottomButton: false,
      showInterconsultationAnchored: false,

      CHAT,
      SECONDARY,
      PROFESSIONAL_ROLE,
      PATIENT_ROLE
    }
  },
  watch: {
    '$store.state.signalr.commandReceived' ({ command, data }) {
      const dataSplitted = data.split(';')
      const appointmentId = parseInt(dataSplitted[0])
      switch (command) {
        case NEW_CHAT_MESSAGE:
          if (this.chatInfo.idAppointment !== appointmentId) {
            this.chats.find(x => x.idAppointment === appointmentId).numMessagesPendingRead += 1
          } else {
            let msgId = parseInt(dataSplitted[1])
            ChatRepository.getMessage(appointmentId, msgId).then((response) => {
              this.chatMessages.push(response.data)
              this.$store.commit('chat/incrementUnreadMessages')
              this.$nextTick(() => {
                this.$uiHelpers.scrollBottom(this.$refs.messageList, true)
              })
            })
          }
          break
        case EDIT_CHAT_MESSAGE:
          if (this.chatInfo.idAppointment === appointmentId) {
            let msgId = parseInt(dataSplitted[1])
            ChatRepository.getMessage(appointmentId, msgId).then((response) => {
              this.$store.commit('chat/editMessage', {msgId: msgId, msg: response.data})
            })
          }
          break
        case DELETE_CHAT_MESSAGE:
          if (this.chatInfo.idAppointment === appointmentId) {
            let msgId = parseInt(dataSplitted[1])
            this.$store.commit('chat/deleteMessageFromChat', msgId)
          }
          break
        case CHAT_CREATED_BY_DOCTOR:
          ChatRepository.getChatById(appointmentId).then((response) => {
            this.setChatFirst(response.data)
          })
          break
        case CHAT_CONSOLIDATED:
          var consolidatedChat = this.chats.find(x => x.idAppointment === appointmentId)
          consolidatedChat.terminated = true
          consolidatedChat.reviewed = consolidatedChat.createdByDoctor != null
          break
        case INTERCONSULTATION_ACTION:
          var chat = this.chats.find(x => x.idAppointment === appointmentId)
          var acceptedConsultation = dataSplitted[1]
          if (acceptedConsultation) {
            chat.interconsultation.accepted = true
          } else {
            this.deleteChatFromList(appointmentId)
          }
          break
        case CHAT_REASSIGNED:
          this.deleteChatFromList(appointmentId)
          ChatRepository.getChatById(appointmentId).then((response) => {
            this.setChatFirst(response.data)
          })
          break
      }
    }
  },
  created () {
    this.$store.dispatch('chat/resetStateOnLoad')
    if (this.pastChat) {
      ChatRepository.getPastChat(this.pastChat).then((response) => {
        this.chats = [response.data.chatInfo]
        this.pastChatInfo = response.data
        if (response.data.chatInfo.isProfessional) this.userType = PROFESSIONAL_ROLE
        this.$store.commit('chat/setChatInfo', response.data.chatInfo)
        this.$store.commit('chat/setChatMessages', response.data.chatMessages)
      })
    } else {
      ChatRepository.getAllUserChats().then((response) => {
        this.chats = response.data
        if (this.anyActiveChats && !this.$uiHelpers.isPortrait) this.selectChat(this.chatList[0])
      })
      if (this.isOpenedFromOuicare) {
        if (this.$route.query.professionalId) {
          this.userType = PROFESSIONAL_ROLE
        }
        this.toggleShowDialog('create')
        this.cleanUrlFromQuery()
      }
    }
  },
  mounted () {
    const checkRef = setInterval(() => {
      if (this.$refs.messageList) {
        this.$store.commit('chat/setRefs', { msgList: this.$refs.messageList, msgInput: this.$refs.messageInput })
        clearInterval(checkRef)
      }
    }, 100)
  },
  methods: {
    cleanUrlFromQuery () {
      const cleanUrl = this.$router.resolve({ path: this.route }).href
      window.history.replaceState(null, '', cleanUrl)
    },
    async selectChat (selectedChat) {
      if (!selectedChat) {
        this.$store.commit('chat/resetMsg')
        this.$store.commit('chat/unselectChat')
      }
      if (this.pastChat) {
        this.$store.commit('chat/setChatInfo', selectedChat)
        this.$store.commit('chat/setChatMessages', this.pastChatInfo.chatMessages)
        return
      }
      if ((this.chatInfo && selectedChat.idAppointment === this.chatInfo.idAppointment)) return
      this.$store.commit('chat/resetMsg')
      await ChatRepository.getChatMessages(selectedChat.idAppointment).then((response) => {
        this.$store.commit('chat/setChatInfo', selectedChat)
        this.$store.commit('chat/setChatMessages', response.data)
        this.$store.commit('chat/incrementUnreadMessages', this.chatInfo.numMessagesPendingRead)
        this.chatInfo.numMessagesPendingRead = 0
				this.$store.dispatch('notifications/get')
        this.$nextTick(() => {
          this.$uiHelpers.centerScreen(this.$refs.messageInput)
          this.scrollToLastRead()
          if (this.dontAttendChatButton) this.$store.dispatch('showInfoAlert', this.$t('chats.dont-attend-chat-warn'))
        })
      })
    },
    contactUser () {
      if (this.isChatWithProfs) {
        this.$router.push('/professional/professional-network')
      } else {
        this.toggleShowDialog('create')
      }
    },
    getPastChats () {
      if (this.$store.getters['session/userIsPatient']) {
        this.$router.push({name: 'pastAppointments', params: { filters: { appointmentType: CHAT } }})
      } else {
        this.$helpers.goToProfessionalWebApp('pastChats')
      }
    },
    getAllChats () {
      return this.$router.push(`/${this.$store.getters['session/userIsPatient'] ? 'patient' : 'professional'}/chats`)
    },
    setChatFirst (chat) {
      this.chats = this.chats.filter(c => c.idAppointment !== chat.idAppointment)
      this.chats.unshift(chat)
    },
    toggleShowDialog (type) {
      this.$store.commit('chat/toggleShowDialog', type)
    },
    setUserType (role) {
      this.userType = role
      if (!this.$uiHelpers.isPortrait) this.selectChat(this.chatList[0])
    },
    goToProfPage () {
      if (!this.chatInfo.searchDisabled && this.chatInfo.customPageUrl) {
        window.open(this.$helpers.getCustomPageUrl(this.chatInfo.customPageUrl))
      }
    },
    goCancelAppointment () {
      var path = `appointments/cancel/${this.chatInfo.idAppointment}`
      if (this.$store.getters['session/userIsPatient']) {
        this.$helpers.goToPatientWebApp(path, this.$apiToken)
      } else {
        this.$helpers.goToProfessionalWebApp(path, this.$apiToken)
      }
    },
    finishChatMessage () {
      this.toggleShowDialog('finish')
      if (!this.chatInfo.showBillingSelectorOnConsolidate) {
        this.consolidateChat({BillingEntityId: null, NoChargeReasonId: null})
      } else {
        this.showFinishModal = true
      }
    },
    emitEPrescription () {
      ChipcardRepository.createChipcardSession(this.chatInfo.patientId, this.chatInfo.idAppointment).then((response) => {
        window.open(response.data.data)
      })
    },
    createChat (newChat) {
      this.setChatFirst(newChat)
      this.selectChat(newChat)
    },
    consolidateChat (consolidateRequest) {
      consolidateRequest.WithReport = false
      ChatRepository.finishChat(this.chatInfo.idAppointment, consolidateRequest).then((response) => {
        this.deleteChatFromList(response.data.data)
        this.showFinishModal = false
        this.$store.dispatch('showSuccessAlert', this.$t('chats.finish-chat-message-success'))
      })
    },
    deleteChatFromList (idAppointment) {
      this.chats = this.chats.filter(x => x.idAppointment !== idAppointment)
      if (!this.$uiHelpers.isPortrait) this.selectChat(this.chatList[0])
    },
    reassignChat () {
      ChatRepository.reassignChat(this.chatInfo.idAppointment).then((response) => {
        if (response.data) {
          this.deleteChatFromList(this.chatInfo.idAppointment)
        }
      })
    },
    scrollToLastRead () {
      const messageList = this.$refs.messageList
      const unreadRef = this.$refs.messagesPendingRead

      if (messageList && unreadRef && unreadRef.length > 0) {
        const containerTop = messageList.getBoundingClientRect().top
        const elementTop = unreadRef[0].getBoundingClientRect().top
        messageList.scrollTop = elementTop - containerTop
      } else {
        this.$uiHelpers.scrollBottom(messageList)
      }
    },
    handleScroll () {
      this.showScrollBottomButtonHandler()
      if (this.interconsultation) {
        this.interconsultationButtonVisibility()
      }
    },
    showScrollBottomButtonHandler () {
      const messageList = this.$refs.messageList
      this.showScrollBottomButton = messageList && messageList.scrollTop + messageList.clientHeight < messageList.scrollHeight - 5
    },
    interconsultationButtonVisibility () {
      if (this.$refs.interconsultationButton[0]) {
        const messageList = this.$refs.messageList
        const interconsultationButton = this.$refs.interconsultationButton[0].$el
        this.showInterconsultationAnchored = interconsultationButton.offsetTop < messageList.scrollTop + interconsultationButton.clientHeight
      }
    },
    getInterconsultationUrl () {
      this.$helpers.goToProfessionalWebApp(`patients/show/${this.interconsultation.matterId}`, this.$apiToken)
    },
    acceptInterconsultation (accept = false) {
      ChatRepository.acceptOrDeclineInterconsultation(this.interconsultation.interconsultationId, accept).then((response) => {
        if (response.status === 200) {
          if (response.data) {
            this.interconsultation.accepted = true
            this.$store.dispatch('showSuccessAlert', this.$t('chats.accepted-consultation'))
          } else {
            this.deleteChatFromList(this.chatInfo.idAppointment)
            this.$store.dispatch('showDangerAlert', this.$t('chats.rejected-consultation'))
          }
        }
      })
    }
  },
  computed: {
    pastChat () {
      return this.$route.params.appointmentId
    },
    isOpenedFromOuicare () {
      return this.$route.query.professionalId != null || this.$route.query.patientId != null
    },
    chatList () {
      if (this.$store.getters['session/userIsProfessional'] && !this.isChatWithProfs) {
        return this.chats.filter(x => !x.isProfessional)
      } else if (this.$store.getters['session/userIsProfessional']) {
        return this.chats.filter(x => x.isProfessional)
      } else {
        return this.chats
      }
    },
    anyActiveChats () {
      return this.chatList.length !== 0
    },
    firstUnreadMessageIndex () {
      return this.chatMessages.findIndex(msg => msg.received && !msg.read)
    },
    firstInterconsultationIndex () {
      return this.chatMessages.findIndex(msg => msg.appointmentId === this.chatInfo.idAppointment)
    },
    isChatWithProfs () {
      return this.userType === PROFESSIONAL_ROLE
    },
    defaultImg () {
      return this.isChatWithProfs ? '/static-appopensalud/img/icons/morillas-svg-icons/primary/doctor.svg' : '/static-appopensalud/img/icons/morillas-svg-icons/primary/user.svg'
    },
    chatInfo () {
      return this.$store.state.chat.selectedChat.user
    },
    chatMessages () {
      return this.$store.state.chat.selectedChat.messages
    },
    dontAttendChatButton () {
      return this.chatInfo.canCancel && this.$store.getters['session/userIsProfessional'] && this.chatInfo.withCompaniesServices
    },
    showFinishButton () {
      return this.chatInfo.canFinish && !this.dontAttendChatButton
    },
    interconsultation () {
      return this.chatInfo.interconsultation
    },
    interconsultationBlurred () {
      return this.interconsultation && (!this.interconsultation.clinicHistoryAllowed || !this.interconsultationActiveAndAccepted)
    },
    interconsultationActiveAndAccepted () {
      return this.interconsultation.accepted && !this.chatInfo.terminated
    },
    hasToAcceptInterconsultation () {
      return this.interconsultation && !this.interconsultationActiveAndAccepted && !this.chatInfo.secondProf
    },
    waitingForDoctorToAccept () {
      return this.interconsultation && !this.interconsultation.accepted && this.chatInfo.secondProf
    }
  }
}
</script>
 
<style lang="scss" scoped>
.chat-container {
  display: flex;
  height: 90vh;
  @include orientation(portrait) {
    height: 80vh;
  }
}

.pending-chat-actions {
    pointer-events: none;
    filter: blur(15px);
}

.interconsultation-confirmation {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: $white;
  border-radius: 23px !important;
  box-shadow: $custom-shadow-bottom;
  border: 0px !important;
  box-sizing: border-box;
  padding: 3rem;
  z-index: 5;
  flex-direction: column;
}

.chat-list {
  float: left;
  min-width: 280px;
  width: 33%;
  color: $gray-600;
  margin-right: 0.5rem;
  @include orientation(portrait) {
    width: 100%;
    margin-right: 0;
  }
}

.pat-profs-select {
  display: flex;
  justify-content: center;
  padding: .8rem;
}

.chat-card {
  background: $white;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 23px !important;
  box-shadow: $custom-shadow-bottom;
  border: 0px !important;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.chat-list ul {
  border-radius: 23px !important;
}

ul {
  margin-top: 0;
  padding-left: 0;
  margin-bottom: 1rem;
}

.chat-list-item {
  position:relative;
  font-size: 0.9rem;
  padding: 2rem 3rem;
  cursor: pointer;

  &:not(.selected):hover {
    background-color: $blue;
    color: $white;
    .unread-messages {
      background: $white;
      color: $blue;
    }
    .chat-list-icon {
      filter: invert(38%) brightness(200%) saturate(100%);
    }
  }

  &.selected {
    border-left: 5px solid $blue;
    background-color: $secondary;
  }
}

.item-block {
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
}

.chat-list-photo {
  width: 2.5rem;
  height: 2.5rem;
  float: left;
  border-radius: 50%;
  margin-right: 1rem;

  &.chat-list-icon {
    border-radius: 0;
  }
}

.photo-align {
  padding-bottom: 0.4rem;
}

.contact-status {
  position: absolute;
  margin: -0.1rem 0 0 -0.1rem;
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  border: 1px solid $gray-600;
  background: $gray-400;
}

.contact-status.connected {
  background: $green;
}

.unread-messages {
  background: $blue;
  color: $white;
  border-radius: 20px;
  position: absolute;
  right: 0.5rem;
  // top: 2.4rem;
  height: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
}
.icon {
  height: 1.3rem;
  width: 2rem;
}
.chat-box {
  width: 67%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  @include orientation(portrait) {
    width: 100%;
  }
  
  .interconsultation-button {
    width: 100%;
    border-width: 1px;
    border-color: $blue;
    background-color: $secondary;
    color: $blue;
    &.anchored {
      position: absolute;
      right: 0;
    }

    .subject {
      color: $black;
    }
  }

  .action-button {
    padding: .3rem .8rem !important;
    span {
      font-size: 0.8rem;
      padding-left: 0.5rem;
      @include mobile {
        display: none;
      }
    }
  }
}

.chat-header {
  width: 100%;
  background-color: $secondary;
  overflow: hidden;
  display: flex;

  .back-arrow {
    float: left;
    margin: 2rem 0 1rem 1rem;
    vertical-align: middle;
  }

  .photo {
    width: 2.8rem;
    height: 2.8rem;
    float: left;
    border-radius: 50%;
    margin: 1rem 1rem 0.75rem;
    vertical-align: middle;
  }

  p {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    float: left;
    margin: 0;
  }

  .chat-id {
    font-size: 0.8rem;
    color: $gray-400;
    width: auto;
    @include mobile {
      font-size: 0.7rem;
    }
  }
}

.user-info {
  display: flex;
  flex-direction: column;
  margin-top: 0.6rem;
  width: 60%;
  @include mobile {
    margin-top: 0.75rem;
  }
}

.chat-list-info {
  display: flex;
  flex-direction: column;
}

.cancel-consultation {
  align-items: right;
  position: absolute;
  right: 0;
  margin: 1rem 1rem 0.75rem;
}

.finish-consultation-options {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    z-index: 3;
    margin-top: -0.25rem;
    padding-bottom: 0.5rem;
    p {
        margin: 0.4rem;
    }
    > .e-prescription,
    > .finish-consultation {
        flex: 1;
        text-align: center;
        justify-content: center;
        display: flex;
        align-items: center;
    }

    > .e-prescription:only-child,
    > .finish-consultation:only-child {
        flex: none;
        width: 100%;
    }
}
.chat-name {
  font-size: 1.2rem;
  @include mobile {
    font-size: 1rem;
  }
}

.chat-content {
  padding: 10px;
  overflow-y: auto;
  flex: 1;

  &::-webkit-scrollbar {
    width: 4px;
  }
}

.messages-pending-read {
  clear: both;
  text-align: center;
  font-weight: bold;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 100%);
}
.interconsultation-start {
  clear: both;
  text-align: center;
  background: linear-gradient(to bottom, $secondary 0%, $background-colour 100%);
}

.scroll-end-btn {
    background: $secondary;
    color: $blue;
    opacity: 70%;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    border: none;
    cursor: pointer;
    padding: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    overflow: hidden;
    right: 1em;
    bottom: 8em;
  }

.z-2 {
  z-index: 2;
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/chat-interconsultations/Chat.vue